import { StaticImageData } from 'next/image';

export interface Tile {
  size?: 'wide' | 'half' | 'third' | 'quarter';
  title: string;
  titleAlign?: 'center' | 'left' | 'right';
  titlePosition?: 'inside' | 'outside';
  imageAlign?: 'center' | 'left' | 'right';
  featured?:
    | 'newFeature'
    | 'comingSoon'
    | 'campaign'
    | 'quickDelivery'
    | 'rare';
  badgeText?: string;
  imageUrl: string | StaticImageData;
  link: string | (() => string);
  className?: string;
}

export interface TenderItem {
  homePageBanner: {
    isShow: boolean;
    message: string | null;
  };
  prepartionTimeInMinute: number;
  message: string;
  preparationKind: string;
  isPreOrder: boolean;
  type: TileType;
}

export enum TileType {
  OnlineConsultation = 0,
  OnlinePharmacy = 1,
  Rare = 2,
  New = 3,
}

export interface TilesItem extends Tile {
  tourTitle?: string;
  tourImageUrl?: string | StaticImageData;
  tourBtnText?: string;
  tourOrder?: number;
  tourDescription?: string[];
}
